import React, { useState } from "react";

export default function LogChoiceModal({
  isOpen,
  title = "Choose how to log",
  subtitle = "Pick the method that matches what you want to analyze.",
  onClose,
  onTakePhoto,
  onUpload,
  onVoice,
  onQuickAdd,
  onManual,
  takePhotoLabel = "📸 Scan with Camera",
  uploadLabel = "⬆️ Upload Photo",
  voiceLabel = "🎤 Analyze Voice Note",
  quickAddLabel = "⚡ Quick Add",
  manualLabel = "✍️ Manual Entry",
}) {
  const [busy, setBusy] = useState(false);

  if (!isOpen) return null;

  const run = async (fn) => {
    if (!fn || busy) return;
    try {
      setBusy(true);
      await Promise.resolve(fn());
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="modal-overlay"
      onMouseDown={() => !busy && onClose?.()}
      style={{ background: "rgba(0,0,0,0.65)" }}
    >
      <div
        className="modal-content"
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          maxWidth: 520,
          width: "100%",
          background: "var(--bg-modal, var(--bg-primary))",
          borderRadius: 16,
          padding: 24,
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          border: "1px solid var(--border-light)",
          color: "var(--text-primary)",
        }}
      >
        <h2 className="heading-3" style={{ marginBottom: 8 }}>
          {title}
        </h2>

        {subtitle ? (
          <div
            className="body-small"
            style={{ marginBottom: 16, color: "var(--text-secondary)" }}
          >
            {subtitle}
          </div>
        ) : null}

        {typeof onVoice === "function" ? (
          <div
            className="body-small"
            style={{ marginBottom: 16, color: "var(--text-muted)" }}
          >
            On Android, after you allow microphone access, wait a moment and then start speaking normally.
          </div>
        ) : null}

        <div style={{ display: "grid", gap: 12 }}>
          {typeof onTakePhoto === "function" ? (
            <button
              className="btn-primary"
              type="button"
              disabled={busy}
              onClick={() => run(onTakePhoto)}
            >
              {takePhotoLabel}
            </button>
          ) : null}

          {typeof onUpload === "function" ? (
            <button
              className="btn-secondary"
              type="button"
              disabled={busy}
              onClick={() => run(onUpload)}
            >
              {uploadLabel}
            </button>
          ) : null}

          {typeof onVoice === "function" ? (
            <button
              className="btn-secondary"
              type="button"
              disabled={busy}
              onClick={() => run(onVoice)}
            >
              {voiceLabel}
            </button>
          ) : null}

          {typeof onQuickAdd === "function" ? (
            <button
              className="btn-secondary"
              type="button"
              disabled={busy}
              onClick={() => run(onQuickAdd)}
            >
              {quickAddLabel}
            </button>
          ) : null}

          {typeof onManual === "function" ? (
            <button
              className="btn-secondary"
              type="button"
              disabled={busy}
              onClick={() => run(onManual)}
            >
              {manualLabel}
            </button>
          ) : null}
        </div>

        <button
          className="btn-secondary"
          type="button"
          disabled={busy}
          onClick={onClose}
          style={{ marginTop: 16, width: "100%" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}